import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../api/ApiService';
import Auth from '../../../../routes/Auth';
import { isSurveyFinished } from '../../../../api/Surveys';

import {
  Wrapper,
  PreTitle,
  Title,
  Text
} from '../../components/ui';

import SkillsProgress from '../../components/skills-progress';

class WorkEthics extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      progressValue: 0
    };
  }

  componentDidMount() {
    const { surveys } = this.props;
    const receiverId = Auth.getUserId();
    const finishedSurveys =
      surveys && surveys.length > 0
        ? surveys.filter(i => isSurveyFinished(i))
        : [];
    const lastSurveyId =
      finishedSurveys.length > 0
        ? finishedSurveys[finishedSurveys.length - 1].id
        : 0;

    if (!lastSurveyId) {
      return this.setState({
        loaded: true
      });
    }

    getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/score/${receiverId}/${lastSurveyId}/`
    ).then(res => {
      const surveyScore = res.body;
      const userScoreQuestions = surveyScore.user_score_question || [];

      const neededQuestion = userScoreQuestions.find(i => i.question === 'Communication');
      const progressValue = neededQuestion ? neededQuestion.median : 0;

      this.setState({
        loaded: true,
        progressValue
      });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      progressValue
    } = this.state;

    return loaded ? (
      <Wrapper>
        <PreTitle>Feedback</PreTitle>
        <Title>Your Communication Skills Rating</Title>
        <SkillsProgress
          title="Communication"
          progressValue={progressValue}
        />
        <Text>
          <p>Articulating your point of view clearly and concisely is a great way to demonstrate good communication skills.  Another great way is through actively listening in which you allow other teammates to share their thoughts, pay close attention to what they have to say, and respond with thoughtful questions or insights.<br /><br /></p>
          <p>If you’ve mastered the art of <a href="https://www.thebalancemoney.com/active-listening-skills-with-examples-2059684" target="_blank" rel="noreferrer">Actively Listening</a>, asking for feedback and using your teammate suggestions, and/or improving the communication amongst teammates then you’re demonstrating very strong and highly desirable communication skills.<br /><br /></p>
          <p>On the flip side, if you avoid discussing team problems,  interrupts and dominates team discussions,  or rarely respond to teammates’ communication then you’re demonstrating low levels of communication skills.</p>
        </Text>
      </Wrapper>
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default WorkEthics;




// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/feedback/communication.js